// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2Sx7u","title":"BackImages_title__3ZCpv","images":"BackImages_images__cjvpS"};